import { render, staticRenderFns } from "./user-posts.vue?vue&type=template&id=15b7fd15&"
import script from "./user-posts.vue?vue&type=script&lang=js&"
export * from "./user-posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports